<form [formGroup]="areaOfSpillForm">

  <div class="contents">

      <div class="area_of_impact">
          <div class="form_input">
            <h2 class="heading">Area Map of Spill</h2>

            <div class="form">

              <div class="input">
                <label for="">Linkage Id</label>
                <input type="text"  (input)="onPopulateUrl()" class="default_input" formControlName="LinkageId"  />
              </div>

              <div class="input">
                  <label for="">Date</label>
                  <input type="date" class="default_input" formControlName="Date"  />
              </div>

              <div class="input">
                <label for="">Area Map Of Spill Description</label>
                <input type="text" class="default_input" formControlName="AreaMapSpillDescription"  />
              </div>

              <div class="input">
                <label for="">Remark</label>
                <textarea class="default_input" cols="30" rows="5"  formControlName="Remarks"></textarea>
              </div>
            </div>

            <div class="btn_holder">
                <button class="default_primary-button" *ngIf="selectedIndex === null" (click)="onAddAreaOfSpill(areaOfSpillForm.value)">Add</button>
                <button class="default_primary-button" *ngIf="selectedIndex !== null" (click)="onAddAreaOfSpill(areaOfSpillForm.value)">Update</button>
                <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

              </div>
          </div>

          <div class="enteries" >
            <div class="the_table">
              <div class="the_head">
                <span class="head_item">S/N</span>
                <span class="head_item">Linkage Id</span>
                <span class="head_item">Date</span>
                <span class="head_item">Area Map Of Spill Description</span>
                <span class="head_item">Remark</span>
                <span class="head_item">Del</span>
              </div>

              <div class="the_row"  *ngFor="let areaOfSpill of getAreaOfSpillFormArray['controls']; index as i"
              (click)="onEdit(i, areaOfSpill.value)" style="cursor: pointer;"
              matTooltip="Click to edit"
                aria-label="Button that displays a tooltip when focused or hovered over">
                <span class="row_data">{{i + 1}}</span>
                <span class="row_data">{{areaOfSpill.value.LinkageId}}</span>
                <span class="row_data">{{areaOfSpill.value.Date | date:'M/d/yyyy'}}</span>
                <span class="row_data">{{areaOfSpill.value.AreaMapSpillDescription}}</span>
                <span class="row_data">{{areaOfSpill.value.Remarks}}</span>
                <span class="row_data" (click)="$event.stopImmediatePropagation()">
                    <button
                    class="delete_icon trash"

                    (click)="deleteAreaOfSpill(i, areaOfSpill.value)">
                    <em class="ti-trash"> </em> </button>
                  </span>

              </div>


            </div>

            <div class="btn_holder" >
              <button class="default_primary-button" (click)="onSubmit()">Submit</button>
          </div>

          </div>



        </div>


    </div>
  </form>
